(function () {
  'use strict';

  // Mengen-Buttons (Produktformular und Warenkorb)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty], [data-qstep]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('.qty__input, .qinput');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty') || btn.getAttribute('data-qstep'), 10);
    var min = input.classList.contains('qinput') ? 0 : 1;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    input.value = Math.max(min, v + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function initForm(form) {
    var pers = form.querySelector('[data-personalisation]');
    var preview = form.querySelector('[data-preview]');
    var errorEl = form.querySelector('[data-form-error]');
    var modeInputs = form.querySelectorAll('[data-mode]');
    var groups = form.querySelectorAll('[data-fields]');

    function currentMode() {
      var checked = form.querySelector('[data-mode]:checked');
      return checked ? checked.getAttribute('data-mode') : null;
    }

    function applyMode() {
      var mode = currentMode();
      if (!mode) return;
      groups.forEach(function (g) {
        var modes = g.getAttribute('data-fields').split(' ');
        var req = (g.getAttribute('data-required-in') || '').split(' ');
        var show = modes.indexOf(mode) !== -1;
        g.hidden = !show;
        g.querySelectorAll('input, textarea, select').forEach(function (el) {
          el.disabled = !show;
          el.required = show && req.indexOf(mode) !== -1;
        });
        var label = g.querySelector('.field__label');
        if (label && g.querySelector('[name="properties[Datum]"]')) {
          label.textContent = req.indexOf(mode) !== -1 ? 'DATUM *' : 'DATUM (OPTIONAL)';
        }
      });
      updatePreview();
    }

    function updatePreview() {
      if (!preview) return;
      var parts = [];
      form.querySelectorAll('[data-preview-src]').forEach(function (el) {
        if (!el.disabled && el.value.trim() !== '') {
          parts.push(el.classList.contains('field__input--upper') ? el.value.trim().toUpperCase() : el.value.trim());
        }
      });
      if (currentMode() === 'motif') {
        var file = form.querySelector('[name="properties[Motiv]"]');
        parts.unshift(file && file.files && file.files[0] ? 'Motiv: ' + file.files[0].name : '[Ihr Motiv]');
      }
      preview.textContent = parts.length ? parts.join('\n') : preview.getAttribute('data-default');
      var font = form.querySelector('[data-font]:checked');
      preview.classList.toggle('is-sans', !!font && font.getAttribute('data-font') === 'sans');
    }

    if (pers) {
      form.addEventListener('input', updatePreview);
      form.addEventListener('change', function (e) {
        if (e.target.hasAttribute('data-mode')) applyMode(); else updatePreview();
      });
      if (modeInputs.length) applyMode(); else updatePreview();
    }

    var variantSelect = form.querySelector('[data-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        document.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = opt.getAttribute('data-price'); });
      });
    }

    form.addEventListener('submit', function (e) {
      if (!form.checkValidity()) {
        e.preventDefault();
        var first = form.querySelector(':invalid');
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Bitte die Pflichtfelder (*) ausfüllen.'; }
        if (first) first.focus();
      }
    });
  }

  document.querySelectorAll('[data-product-form]').forEach(initForm);

  // Menü: Escape und Klick außerhalb schließen
  function closeMenus() {
    document.querySelectorAll('details[data-menu][open]').forEach(function (d) { d.removeAttribute('open'); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenus(); });
  document.addEventListener('click', function (e) { if (!e.target.closest('details[data-menu]')) closeMenus(); });

  // Vorher/Nachher-Vergleich
  document.querySelectorAll('[data-compare]').forEach(function (c) {
    var r = c.querySelector('.compare__range');
    if (!r) return;
    var set = function (v) { c.style.setProperty('--pos', v + '%'); };
    r.addEventListener('input', function () { c.dataset.touched = '1'; set(r.value); });
    set(r.value);
  });

  /* ---------- Editorial motion ---------- */
  var root = document.documentElement;
  if (!root.classList.contains('motion') || !('IntersectionObserver' in window)) {
    root.classList.remove('motion');
    return;
  }
  window.__ssMotion = true;

  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function ms(el, prop) {
    var v = getComputedStyle(el).getPropertyValue(prop).trim();
    return v ? parseFloat(v) * (v.indexOf('ms') > -1 ? 1 : 1000) : 0;
  }

  // Headline in Zeilen zerlegen (Maske pro Zeile). Nach der Animation wird der Originaltext zurückgesetzt,
  // damit der Umbruch bei Größenänderung wieder frei fließt.
  function splitLines(el) {
    var onlyBr = Array.prototype.every.call(el.children, function (c) { return c.tagName === 'BR'; });
    if (el.children.length && !onlyBr) { el.classList.add('is-split', 'ln-solo'); el.innerHTML = '<span class="ln"><span class="ln__i">' + el.innerHTML + '</span></span>'; return; }
    el.setAttribute('data-orig', el.innerHTML);
    // Feste Umbrüche (<br>) bleiben erhalten; jedes Segment bricht zusätzlich natürlich um
    var segs = el.innerHTML.split(/<br\s*\/?>/i).map(function (h) {
      var d = document.createElement('div'); d.innerHTML = h;
      return d.textContent.replace(/\s+/g, ' ').trim();
    }).filter(Boolean);
    var lines = [];
    segs.forEach(function (seg) {
      el.innerHTML = seg.split(' ').map(function (w) { return '<span class="w">' + esc(w) + '</span>'; }).join(' ');
      var top = null;
      el.querySelectorAll('.w').forEach(function (s) {
        var t = s.offsetTop;
        if (top === null || Math.abs(t - top) > 3) { lines.push([]); top = t; }
        lines[lines.length - 1].push(s.textContent);
      });
    });
    el.innerHTML = lines.map(function (l, i) {
      return '<span class="ln"><span class="ln__i" style="--i:' + i + '">' + l.map(esc).join(' ') + '</span></span>';
    }).join('');
    el.classList.add('is-split');
  }
  function settleLines(el) {
    var n = el.querySelectorAll('.ln').length;
    var total = ms(el, '--delay') + n * 90 + 1200;
    setTimeout(function () {
      var orig = el.getAttribute('data-orig');
      if (orig !== null) el.innerHTML = orig;
      el.classList.add('is-done');
    }, total);
  }

  // Schreibmaschine: Zeichen erscheinen nacheinander, ohne Layout-Sprung
  function typeIn(el) {
    if (el.children.length) return;
    var text = el.textContent;
    el.setAttribute('data-orig', el.innerHTML);
    el.setAttribute('aria-label', text.trim());
    el.innerHTML = text.split('').map(function (c) {
      return c === ' ' ? ' ' : '<span class="ch" aria-hidden="true">' + esc(c) + '</span>';
    }).join('');
    var chars = el.querySelectorAll('.ch'), i = 0;
    var start = ms(el, '--d');
    setTimeout(function step() {
      if (i > 0) chars[i - 1].classList.remove('cur');
      if (i < chars.length) {
        chars[i].classList.add('on', 'cur');
        i++;
        setTimeout(step, 26 + Math.random() * 34);
      } else {
        chars[chars.length - 1].classList.add('cur');
        setTimeout(function () { el.innerHTML = el.getAttribute('data-orig'); el.removeAttribute('aria-label'); }, 1400);
      }
    }, start);
  }

  function reveal(el) {
    if (el.classList.contains('is-in')) return;
    if (el.hasAttribute('data-type')) typeIn(el);
    el.classList.add('is-in');
    if (el.hasAttribute('data-lines')) settleLines(el);
  }

  // Katalog: leichte Staffelung pro Spalte
  document.querySelectorAll('.catalogue').forEach(function (grid) {
    Array.prototype.forEach.call(grid.children, function (c, i) { c.style.setProperty('--d', (i % 4) * 90 + 'ms'); });
  });

  var targets = document.querySelectorAll('[data-lines], [data-fade], [data-type], [data-clip], [data-rule]');
  document.querySelectorAll('[data-lines]').forEach(splitLines);

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  var hero = document.querySelector('[data-hero]');
  targets.forEach(function (el) {
    if (hero && hero.contains(el)) return;
    io.observe(el);
  });
  if (hero) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        hero.querySelectorAll('[data-lines], [data-fade], [data-type], [data-clip], [data-rule]').forEach(reveal);
      });
    });
  }

  // Vergleich: einmaliger, ruhiger Hinweis-Schwenk, sobald er ins Bild kommt
  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      cio.unobserve(en.target);
      var c = en.target, r = c.querySelector('.compare__range');
      if (!r) return;
      var from = 78, to = 50, dur = 1400, t0 = null;
      c.style.setProperty('--pos', from + '%');
      setTimeout(function () {
        requestAnimationFrame(function step(ts) {
          if (c.dataset.touched) return;
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          var v = from + (to - from) * e;
          c.style.setProperty('--pos', v.toFixed(2) + '%');
          r.value = Math.round(v);
          if (p < 1) requestAnimationFrame(step);
        });
      }, 700);
    });
  }, { threshold: 0.35 });
  document.querySelectorAll('[data-compare]').forEach(function (c) { cio.observe(c); });

  // Sehr leichte Parallaxe auf ausgewählten Bildern (nur ab Tablet)
  var px = Array.prototype.slice.call(document.querySelectorAll('[data-parallax] .frame__img'));
  if (px.length && window.matchMedia('(min-width: 750px)').matches) {
    var ticking = false;
    var update = function () {
      var vh = window.innerHeight;
      px.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.translate = '0 ' + (p * -18).toFixed(2) + 'px';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
})();
